<template>
  <div class="flex">
      <DutyCellWithDetailView showTitle :column="{columnName:'z9Duty'}" :absence="absence" :is-assigned-to-different-view="isAssignedToDifferentView"></DutyCellWithDetailView>
      Linie/Kurs {{lineTrack}}
    <FromTo :isDisabled="isDisabled" :asChip="false" :column="{columnName:'z9FromTo'}" :absence="absence"></FromTo>

  </div>
</template>
<script>
import FromTo from './FromTo.vue';
import DutyCellWithDetailView
  from "@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/absenceTableCells/DutyCellWithDetailView.vue";

export default {
  name: 'DutyLineTrack',
  components: {
    DutyCellWithDetailView,
    FromTo,
  },
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
    isDisabled:{type:Boolean,default:false}
  },
  computed: {
    duty() {
        return this.absence.z9Duty || ''
    },
    lineTrack() {
        return this.absence.z9Line || ''
    }
  },
};
</script>